import { Injectable, inject } from '@angular/core';

import { LoaderStylesService } from '@frontend/loaders';
import { ModuleLoaderService } from '@frontend/sports/deferred/feature/module-loader';
import { Observable, forkJoin, from, map } from 'rxjs';

import { SportsProductMenuModule } from '../sports-product-menu/sports-product-menu.module';

@Injectable({ providedIn: 'root' })
export class SportsProductMenuLoaderService {
    private moduleLoader = inject(ModuleLoaderService);
    stylesLazyLoadingService = inject(LoaderStylesService);

    loadAndInitModule(): Observable<SportsProductMenuModule> {
        const moduleLoader = this.moduleLoader.loadModule<SportsProductMenuModule>('SportsProductMenuModule', () =>
            import(/* webpackChunkName: "ms-sports-product-menu" */ '../sports-product-menu/sports-product-menu.module').then(
                (m) => m.SportsProductMenuModule,
            ),
        );
        const stylesLoader = from(this.stylesLazyLoadingService.loadStyles([{ id: 'sports-product-menu', type: 'theme' }]));

        return forkJoin([moduleLoader, stylesLoader]).pipe(map(([ref, _]) => ref.instance));
    }
}
